
export class RulePredicateEvaluationResultModel {
  id: string;
  predicate: string;
  result: boolean;
  isProviderPredicateNotValid: boolean;
}
